import { FormTooltip } from '@components/formInputs/FormTooltip';
import { RestaurantEventDisclaimer } from '@shared/types/restaurantEvents';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './EventDisclaimers.scss';

interface EventDisclaimersProps {
  disclaimers: RestaurantEventDisclaimer[];
  isDisclaimerChecked: (id: string) => boolean;
  handleDisclaimerToggle: (id: string, checked: boolean) => void;
}

export const EventDisclaimers = ({
  disclaimers,
  isDisclaimerChecked,
  handleDisclaimerToggle,
}: EventDisclaimersProps) => {
  return (
    <div className={styles.container}>
      {disclaimers.length > 0 &&
        disclaimers.map((disclaimer) => (
          <label
            key={disclaimer.id}
            htmlFor={disclaimer.id}
            className={cx(typography.c3, styles.termsCheckbox)}
          >
            <input
              checked={isDisclaimerChecked(disclaimer.id)}
              disabled={false}
              id={disclaimer.id}
              onChange={(event) =>
                handleDisclaimerToggle(disclaimer.id, event.target.checked)
              }
              type="checkbox"
            />
            <span className={styles.labelText}>{disclaimer.title}</span>
            {disclaimer.description && (
              <FormTooltip
                label={disclaimer.title}
                text={disclaimer.description}
              />
            )}
          </label>
        ))}
    </div>
  );
};
